import { SDK_CAPITALIZE_NAMES, SDK_ENUMS, SDK_IDS } from '../utils/constant'
import { store } from '../store/store'
import toasterService from '../utils/toaster'

const requestParameters = {

  getMethodParameters ({ methodName, methodParameters }) {
    if (requestParameters[methodName + 'Parameters']) {
      return requestParameters[methodName + 'Parameters']({ methodParameters })
    } else {
      return methodParameters
    }
  },

  bootstrapParameters () {
    let selectedSdks = store.getters.loadedSDKs
    let sdkConfigs = {}
    Object.keys(SDK_IDS).forEach((sdkName) => {
      if (selectedSdks.includes(sdkName)) { sdkConfigs[sdkName] = { URL: store.getters.sdkJSUrlByNetwork(sdkName.toUpperCase()) } }
    })
    this.loadAuthSDK()
    return sdkConfigs
  },

  loadAuthSDK () {
    store.dispatch('updateEnableAuthSDKFlow', true).then(res => {
    }).catch(err => {
      toasterService.onFailure(err)
    })
  },

  initParameters ({ methodParameters }) {
    const srciTransactionId = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, a => (a ^ Math.random() * 16 >> a / 4).toString(16))
    store.commit('srcTransactionId', srciTransactionId)
    let initParameters = {
      srciTransactionId: srciTransactionId,
      dpaTransactionOptions: methodParameters.dpaTransactionOptions,
      sdkSpecificParameters: this.getSdkSpecificParameters()
    }
    return initParameters
  },

  identityLookupParameters ({ methodParameters }) {
    let _identityType = store.getters.isIdentityTypeMobile ? SDK_ENUMS.IdentityType.mobilePhoneNumber : SDK_ENUMS.IdentityType.emailAddress
    let identityLookupParams = {
      consumerIdentity: {
        identityProvider: SDK_ENUMS.IdentityProvider.src,
        identityType: _identityType,
        identityValue: methodParameters
      }
    }
    return identityLookupParams
  },

  initiateIdentityValidationParameters ({ methodParameters }) {
    let initiateIdentityParameters = {
      requestedValidationChannelId: methodParameters
    }
    return initiateIdentityParameters
  },

  completeIdentityValidationParameters ({ methodParameters }) {
    let completeIdValidationParams = {
      validationData: methodParameters
    }
    return completeIdValidationParams
  },

  authenticationMethodsLookupParameters ({ methodParameters }) {
    let _identityType = store.getters.isIdentityTypeMobile ? SDK_ENUMS.IdentityType.mobilePhoneNumber : SDK_ENUMS.IdentityType.emailAddress
    const requestParameters = {
      consumerIdentity: {
        identityProvider: SDK_ENUMS.IdentityProvider.src,
        identityType: _identityType,
        identityValue: methodParameters
      },
      sdkSpecificParameters: this.getSdkSpecificParameters()
    }
    return requestParameters
  },

  authenticateParameters ({ methodParameters }) {
    let isIdentityTypeMobile = Object.keys(methodParameters.params).toString()
    let _identityType = isIdentityTypeMobile === 'mobileNumber' ? SDK_ENUMS.IdentityType.mobilePhoneNumber : SDK_ENUMS.IdentityType.emailAddress

    const requestParameters = {
      consumerIdentity: {
        identityProvider: SDK_ENUMS.IdentityProvider.src,
        identityType: _identityType,
        identityValue: methodParameters.params
      },
      authenticationMethod: methodParameters.authenticationMethod,
      sdkSpecificParameters: this.getSdkSpecificParameters()
    }
    return requestParameters
  },

  getSrcProfileParameters () {
    let isRecognized = store.getters.isRecognized
    let idTokens
    if (isRecognized.recognized) {
      idTokens = isRecognized.idTokens
    } else {
      idTokens = store.getters.consumerAuthorization
    }
    return { idTokens }
  },

  checkoutParameters ({ methodParameters }) {
    let dpaTransactionOptions = methodParameters.dpaTransactionOptions
    let sdkSpecificDpaTransactionOptions = {
      ...requestParameters.getPayloadIndicatorObject(),
      paymentOptions: requestParameters.getPaymentOptionsByNetwork(methodParameters.network)
    }
    return {
      ...methodParameters,
      dpaTransactionOptions,
      sdkSpecificDpaTransactionOptions
    }
  },

  /**
   * get Sdk Other Parameters
   * @param sdkType
   * @returns {*}
   */
  getSdkSpecificParameters () {
    let selectedSdks = store.getters.loadedSDKs
    let sdkSpecificParameters = {}
    Object.keys(SDK_IDS).forEach((sdkName, sdkKey) => {
      if (selectedSdks.includes(sdkName)) {
        sdkSpecificParameters[sdkName] = {
          srcInitiatorId: store.getters.srcInitiatorIdByNetwork(sdkKey),
          srcDpaId: store.getters.dpaIdByNetwork(sdkKey),
          host: store.getters.hostByNetwork(sdkName.toUpperCase()),
          dpaTransactionOptions: {
            ...requestParameters.getPayloadIndicatorObject(),
            paymentOptions: store.getters.checkoutMethod === 'aggregator' ? [ requestParameters.getPaymentOptionsByNetwork(sdkName) ] : requestParameters.getPaymentOptionsByNetwork(sdkName)
          }
        }
      }
    })
    return sdkSpecificParameters
  },

  getPaymentOptionsByNetwork (sdkName) {
    return {
      dpaDynamicDataTtlMinutes: store.getters.validityPeriodMinutes,
      dpaPanRequested: false,
      dynamicDataType: store.getters.dynamicDataTypeByNetwork(SDK_CAPITALIZE_NAMES[sdkName])
    }
  },

  getPayloadIndicatorObject () {
    return {
      payloadTypeIndicatorCheckout: store.getters.payloadTypeIndicatorCheckout,
      payloadTypeIndicatorPayload: store.getters.payloadTypeIndicatorPayload,
      payloadTypeIndicator: store.getters.payloadTypeIndicatorPayload
    }
  }
}
export default requestParameters
